import gql from "graphql-tag";
import { useMemo } from "react";
import {
  RoleThinFragment,
  useGetRolesForSelectQuery,
} from "./useRoles.generated";

type UseRoles = {
  roles: RoleThinFragment[];
  loading: boolean;
};

const useRoles = (): UseRoles => {
  // cache-first: this hook is mounted by many selects/filters (sometimes per
  // row), and the global cache-and-network default refired the same query on
  // every mount. Role mutations refetch GetRolesForSelect explicitly instead.
  const { data, previousData, loading } = useGetRolesForSelectQuery({
    fetchPolicy: "cache-first",
  });
  const roles = useMemo(() => {
    const d = data || previousData;
    return d?.Roles.objects || [];
  }, [data, previousData]);
  return {
    roles,
    loading,
  };
};

gql`
  query GetRolesForSelect {
    Me {
      user {
        id
        userType
        roles {
          id
          roleLevelV2
        }
      }
    }
    Roles {
      objects {
        ...RoleThin
      }
    }
  }
  fragment RoleThin on Role {
    id
    name
    roleLevelV2
    userCount
    roleGroupMemberships {
      id
      roleGroup {
        id
        name
      }
    }
    roleActionPermissions {
      ...RoleActionPermissions
    }
    directReports {
      id
      name
    }
  }
`;

export default useRoles;
